import { render, staticRenderFns } from "./StatusTransitionRecord.vue?vue&type=template&id=57b7a03e&scoped=true"
import script from "./StatusTransitionRecord.vue?vue&type=script&lang=js"
export * from "./StatusTransitionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b7a03e",
  null
  
)

export default component.exports